import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router, RouterModule } from "@angular/router";

import { AuthService } from "../../../core/services/auth.service";
import { AUTH_PROVIDER } from "../../../core/auth/auth-provider.token";
import { AvatarComponent } from "../avatar/avatar.component";
import { IconComponent, type IconName } from "../icon/icon.component";

interface INavItem {
  label: string;
  icon: IconName;
  route: string;
  badge?: string;
}

interface INavGroup {
  label: string;
  items: INavItem[];
  /** Shown only to a Davaco admin (ct-admin). */
  adminOnly?: boolean;
}

@Component({
  selector: "app-sidebar",
  standalone: true,
  imports: [RouterModule, AvatarComponent, IconComponent],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {

  private readonly router = inject(Router);

  private readonly authService = inject(AuthService);

  private readonly authProvider = inject(AUTH_PROVIDER);

  protected readonly profile = this.authService.userProfile;

  protected readonly avatarUrl = this.authService.avatarUrl;

  protected navGroups: INavGroup[] = [
    {
      label: "OPERATIONS",
      items: [
        { label: "Service Providers", icon: "building", route: "/service-providers", badge: "412" },
      ],
    },
    {
      label: "Admin",
      adminOnly: true,
      items: [
        { label: "Service-Accounts", icon: "key", route: "/admin/service-accounts" },
      ],
    },
  ];

  /** The groups this person may see: the Admin group only for a ct-admin. */
  protected visibleGroups(): INavGroup[] {
    const isAdmin: boolean = this.authService.isDavacoAdmin();
    return this.navGroups.filter((group) => group.adminOnly !== true || isAdmin);
  }

  protected isActive(route: string): boolean {
    return this.router.url === route || this.router.url.startsWith(route + "/");
  }

  protected onLogout(): void {
    void this.authProvider.logout();
  }
}
